import Report from "@/api/Report";
import Production from "@/api/Production";
import CoverholderPolicyProduction from "@/api/CoverholderPolicyProduction";
import Submissions from "@/api/Submissions";
import WorkInProgress from "@/api/WorkInProgress";
import Referral from "@/api/Referral";
import OrderSubmission from "@/api/OrderSubmission";
import SavedQuote from "@/api/SavedQuote";
import Renewal from "@/api/Renewal";
import UnderwritingTools from "@/api/UnderwritingTools";
import UnderwritingToolsOther from "@/api/UnderwritingToolsOther";
import ClaimNotifications from "@/api/ClaimNotifications";
import DocumentCategory from "@/api/DocumentCategory";
import DocumentType from "@/api/DocumentType";
import EmailAddress from "@/api/EmailAddress";
import SalesDocument from "@/api/SalesDocument";
import PolicyCertificate from "@/api/PolicyCertificate";
import DashboardPolicyProduction from "@/api/DashboardPolicyProduction";
import ChartInfo from "@/api/ChartInfo";
import UserInformation from "@/api/UserInformation";
import UserRoles from "@/api/UserRoles";
import SubmitRater from "@/api/SubmitRater";
import GridOptions from "@/api/GridOptions";
import DashboardData from "@/api/DashboardData";
import DashboardDataCoverholder from "@/api/DashboardDataCoverholder";
import DashboardDetails from "@/api/DashboardDetails";
import Impersonate from "@/api/Impersonate";
import CoverholderOrderSubmission from "@/api/CoverholderOrderSubmission";
import CoverholderSaveQuote from "@/api/CoverholderSaveQuote";
import CoverholderReferral from "@/api/CoverholderReferral";
import CoverholderPolicyPending from "@/api/CoverholderPolicyPending";
import News from "@/api/News";
import HeaderInfo from "@/api/HeaderInfo";
import ProducerCommissions from "@/api/ProducerCommissions";

class Manager {
  constructor() {
    this.reports = Report;
    this.productions = Production;
    this.coverholderPolicyProductions = CoverholderPolicyProduction;
    this.coverholderPolicyPendings = CoverholderPolicyPending;
    this.coverholderOrderSubmissions = CoverholderOrderSubmission;
    this.coverholderReferrals = CoverholderReferral;
    this.coverholderSaveQuotes = CoverholderSaveQuote;
    this.submissions = Submissions;
    this.workInProgress = WorkInProgress;
    this.referral = Referral;
    this.orderSubmission = OrderSubmission;
    this.savedQuote = SavedQuote;
    this.renewal = Renewal;
    this.underwritingTools = UnderwritingTools;
    this.underwritingToolsOther = UnderwritingToolsOther;
    this.claimNotifications = ClaimNotifications;
    this.documentCategories = DocumentCategory;
    this.documentTypes = DocumentType;
    this.emailAddresses = EmailAddress;
    this.salesDocument = SalesDocument;
    this.policyCertificate = PolicyCertificate;
    this.dashboardPolicyProduction = DashboardPolicyProduction;
    this.userInformation = UserInformation;
    this.userRoles = UserRoles;
    this.chartInfo = ChartInfo;
    this.headerInfo = HeaderInfo;
    this.gridOptions = GridOptions;
    this.dashboardData = DashboardData;
    this.dashboardDataCoverholder = DashboardDataCoverholder;
    this.dashboardDetails = DashboardDetails;
    this.impersonate = Impersonate;
    this.submitRater = SubmitRater;
    this.news = News;
    this.producerCommissions = ProducerCommissions;
  }
}

export default Manager;
